import React from 'react';
import './style.css';

function Error(){
    return(
        <div className="error">
            <h1>Sorry we do not have anything you are instrested in!</h1>
        </div>
    )
}

export default Error;